"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfBuilder = void 0;
const react_1 = __importStar(require("react"));
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const utility_1 = require("../utility");
const native_1 = require("@react-navigation/native");
const root_navigation_1 = require("../navigation/root_navigation");
const native_stack_1 = require("@react-navigation/native-stack");
const page_builder_1 = __importDefault(require("./page_builder"));
const MfBuilder = (props) => {
    const [isLoading, setLoading] = react_1.default.useState(true);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        yield SharedPropsService_1.default.setGlobalProps({
            widgetRegistry: props.widgetRegistry,
            ref: {},
            routeMap: props.routeMap,
        });
        yield setLoading(false);
    });
    react_1.default.useEffect(() => {
        init();
    }, []);
    return isLoading ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(RouteBuilder, Object.assign({}, props)));
};
exports.MfBuilder = MfBuilder;
const Stack = (0, native_stack_1.createNativeStackNavigator)();
const RouteBuilder = (props) => {
    const config = {
        screens: {},
    };
    const renderMF = (0, react_1.useCallback)((nav, routeId) => {
        return react_1.default.createElement(page_builder_1.default, Object.assign({}, props));
    }, []);
    const StackScreen = (0, react_1.useMemo)(() => Object.keys(props.routeMap).map((routeId) => {
        config.screens[`${routeId}`] = {
            path: `${routeId}/:params?`,
            exact: true,
        };
        return (react_1.default.createElement(Stack.Screen, { name: routeId, key: routeId, options: {
                presentation: 'transparentModal',
            } }, (navProps) => renderMF(navProps, routeId)));
    }), []);
    //@todo - remove this from platform
    /** [Toggle Navigation Linking Added to send notification to Android/iOS WebView Navigation Changes] **/
    const partnerPlatform = (0, utility_1.getCurrentURL)()
        .toLowerCase()
        .includes('partnerplatform');
    const platform = (0, utility_1.getCurrentURL)()
        .toLowerCase()
        .includes('platform');
    return (react_1.default.createElement(native_1.NavigationContainer, { independent: true, ref: root_navigation_1.navigationRef, documentTitle: {
            enabled: false,
        }, linking: {
            enabled: partnerPlatform && platform,
            prefixes: [
                'https://app.voltmoney.in',
                'voltmoney://',
                'http://localhost:3000',
            ],
            config,
            getPathFromState: (state, options) => {
                const endPoints = (0, native_1.getPathFromState)(state, options)
                    .toLowerCase()
                    .split('/')[1];
                const url = (0, utility_1.getCurrentURL)();
                const finalUrl = `${url}/${endPoints}`;
                return finalUrl;
            },
        } },
        react_1.default.createElement(Stack.Navigator, { screenOptions: {
                headerShown: false,
                statusBarTranslucent: true,
            }, initialRouteName: props.routeCurrent }, StackScreen)));
};
//# sourceMappingURL=mf_builder.js.map